import React from 'react';

import mixin from 'react-mixin';
import { changeDecimalString } from 'utils/formatting_utils';
import { getMobileDetect } from 'utils/dom_utils';

@mixin.decorate(window.CssClassMixin)
@mixin.decorate(window.InputComponentMixin)

export default class InputNumber extends React.Component {
	constructor(props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ value: nextProps.value });
	}

	componentDidMount() {
		this.focusInputReadOnly();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.warnings !== this.props.warnings && this.props.warnings) {
			$(`.tooltipped`).tooltip();
		}
	}

	focusInputReadOnly(){
		let readOnly = this.props.readOnly;

		if(readOnly){
			let id = this.props.id;
			let input = $(`#${id}`);

			input.on('focus', () => {
				input.select();
			})
		}
	}

	handleChange(event) {
		const { maxLength, digits, component } = this.props;
		const value = event.target.value;
		const valueFormatted = changeDecimalString(value, maxLength, digits, component);

		//manda pra api
		this.props.onChange(event, valueFormatted, this);

		//manda pra tela
		this.setState({ value: valueFormatted, changeValue: true });
	}

	handleBlur(event) {
		if (this.state.changeValue) {
			if (this.props.gridFormParent) {
				Form.fields(this.props.gridFormParent).fields(this.props.id).warnings('').apply();
			}
			else {
				if (Form.fields(this.props.id)) {
					Form.fields(this.props.id).warnings('').apply();
				}
			}
		}

		if (this.props && this.props.onBlur)
			this.props.onBlur(event);
	}

	returnValue() {
		const { value } = this.state;
		return value;
	}

	classActionsAndWarnings(){
		const actionsFields = this.props.actions;
		const warningsFields = this.props.warnings;
		let className = '';

		if (actionsFields && actionsFields.length > 0)
			className += ' actions-field';

		if (warningsFields)
			className += ' warnings-field';

		return className;
	}

	renderInput(){
		return (
			<input {...this.props}
				placeholder={this.getPlaceholder()}
				className={this.inputClassName() + this.classActionsAndWarnings()}
				onChange={this.handleChange}
				onBlur={this.handleBlur}
				value={this.returnValue()}
				type={getMobileDetect() === "iOS" ? 'text' : 'tel'}
				maxLength={null}
				ref="input" />
		);
	}

	render() {
		return this.renderInput();
	}
}
